import { jsx as _jsx } from "react/jsx-runtime";
export function AcChevron({ expanded }) {
    return (_jsx("span", { className: "ac-chevron", "data-expanded": expanded ? 'true' : 'false', "aria-hidden": "true", children: expanded ? '▾' : '▸' }));
}
//# sourceMappingURL=AcChevron.js.map